export default el => {
    const zone = el.querySelector('.js-search-zone');
    const results = zone.querySelector('.js-search-results');
    const form = document.querySelector('.js-search-form');
    const filters = el.querySelectorAll('.js-filter');
    const tags = el.querySelectorAll('.js-tag');
    const background = el.querySelector('.js-search-background');
    const backgroundTmp = el.querySelector('.js-search-background-tmp');
    const backgroundContainer = el.querySelector('.js-search-background-container');
    const h1 = document.querySelector('.js-search-h1');

    const loading = (action = "") => {
        if (action == "add") {
            zone.classList.add('loading');
        }

        else if (action == "remove") {
            zone.classList.remove('loading');
        }

        else {
            zone.classList.toggle('loading');
        }
    }

    const ajax = (paged = 1, scroll = false) => {
        if (!zone.classList.contains('loading')) {
            loading("add");
        }

        if (scroll) {
            const yOffset = -50;
            const y = zone.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }

        const ajax_url = ParamsData.wp_ajax_url;
        const formData = new FormData(form);
        const xhr = new XMLHttpRequest();

        formData.append('action', 'search');
        formData.append('paged', paged);
        formData.append('cpt', el.dataset.searchCpt);

        xhr.open('POST', ajax_url, true);
        xhr.onreadystatechange = () => {

            if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 0)) {
                const response = JSON.parse(xhr.response);

                // remove loading
                setTimeout(() => {

                    // replace content by response
                    zone.innerHTML = response.html;
                    conditioner.hydrate(zone);
                    window.lazyLoadInstance.update();

                    window.history.pushState({}, '', response.url);

                    var link = document.querySelector("link[rel='canonical']");
                    if (link) link.setAttribute('href', response.url);

                    if (response.title) {
                        document.title = response.title;
                    }

                    if (response.h1 && h1) {
                        h1.innerHTML = response.h1;
                    }

                    // reinit pagination links for ajax
                    initPaginationLinks();
                    loading("remove");
                }, 1000)
            }

            else {
                setTimeout(() => {
                    loading("remove");
                }, 1000)
            }
        };

        xhr.send(formData);
    }

    const initPaginationLinks = () => {
        const paginationLinks = zone.querySelectorAll('.js-pagination-link');
        paginationLinks.forEach(paginationLink => {
            paginationLink.addEventListener('click', (e) => {
                e.preventDefault();
                ajax(paginationLink.dataset.index, true);
            })  
        })
    }

    const setGradientBackground = () => {

        if (!background || !backgroundTmp || !backgroundContainer) return;

        const activeFilters = el.querySelectorAll('.js-filter[data-search-color]:checked');
        
        backgroundTmp.style.background = background.style.background;
        backgroundTmp.classList.add('active');

        var css = `
            linear-gradient(
                55deg,
        `;

        if (activeFilters.length == 0) {
            background.style.removeProperty('background');
            backgroundContainer.classList.remove('filtered');
        } else {
            if (activeFilters.length == 1) {
                css += `
                    var(${activeFilters[0].dataset.searchColor}) 0%, var(${activeFilters[0].dataset.searchColor}) 100%
                `;
            }

            else {
                activeFilters.forEach((filter, i) => {
                    css += `
                        var(${filter.dataset.searchColor}) ${i == 0 ? 0 : (100 / (activeFilters.length - 1)) * i}%${i < activeFilters.length - 1 ? ',' : ''}
                    `;
                })
            }

            css += `
                )
            `;

            background.style.background = css;
            backgroundContainer.classList.add('filtered');
        }

        setTimeout(() => {
          backgroundTmp.classList.remove('active');
        }, 10);
    }

    if (filters) {
        filters.forEach(filter => {
            filter.addEventListener('change', () => {
                ajax(1);
                setGradientBackground();

                const datas = {...TrackingData};
                datas.event = 'dataLayer.ready';

                // tracking residences
                const checkedResidences = el.querySelectorAll('.js-filter[name="residences[]"]:checked');
                const checkedResidencesDatas = [];
                checkedResidences.forEach(checkedResidence => {
                    checkedResidencesDatas.push(checkedResidence.dataset.text);
                });

                if (checkedResidencesDatas) {
                    if (!datas.product) datas.product = {};

                    datas.product.house = checkedResidencesDatas
                }

                // tracking accomodation
                const checkedLocationTypes = el.querySelectorAll('.js-filter[name="location_type[]"]:checked');
                const checkedLocationTypesDatas = [];
                checkedLocationTypes.forEach(checkedLocationType => {
                    checkedLocationTypesDatas.push(checkedLocationType.dataset.text);
                });

                if (checkedLocationTypesDatas) {
                    if (!datas.product) datas.product = {};

                    datas.product.accomodation = checkedLocationTypesDatas;
                }

                window.dataLayer.push(datas);
                
            })
        })
    }

    if (tags) {
        tags.forEach(tag => {
            tag.addEventListener('change', () => {
                ajax(1);
            })
        })
    }

    initPaginationLinks();
    setGradientBackground();
};